import { Facts } from "lib/models/list-models";
import { ItemModel } from "lib/services/catalogical-models";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";

export const calculateItemsDiff = (selectedItems: ItemModel[], initialItems?: ItemModel[]) => ({
  added: selectedItems.filter((item) => !initialItems?.some((initial) => initial.taxonomyId === item.taxonomyId)),
  removed:
    initialItems?.filter((initial) => !selectedItems.some((item) => item.taxonomyId === initial.taxonomyId)) || [],
});

export const buildJobFamilyRule = (jobFamilyValue: string) => ({
  conditions: {
    all: [
      {
        fact: Facts.JOB_FAMILY,
        operator: "contains",
        value: jobFamilyValue,
      },
    ],
  },
});

export const getJobFamilyFromRule = (rule: any): string | undefined =>
  rule?.conditions?.all?.find((c: any) => c.fact === Facts.JOB_FAMILY)?.value;

export const fetchRecommendedTools = async (
  jobFamilies: string[],
  evaluateLists: (criteria: any, options: any) => Promise<any[]>,
  allJobFamilyCategory: string
): Promise<ItemModel[]> => {
  const filteredJobFamilies = jobFamilies.filter((jobFamily) => jobFamily !== allJobFamilyCategory);

  if (filteredJobFamilies.length === 0) return [];

  const lists = await evaluateLists({ jobFamilyName: filteredJobFamilies }, { includeItemDetails: true });

  const toolsMap = new Map(
    lists
      .flatMap((list) => list.fullItems)
      .filter((tool) => tool?.taxonomyId)
      .map((tool) => [tool.taxonomyId, tool])
  );
  return sortToolsByWilsonRating(Array.from(toolsMap.values()));
};

export const sortToolsByWilsonRating = (tools: ItemModel[]): ItemModel[] =>
  tools.sort((a, b) => (b.feedback?.wilsonRating ?? 0) - (a.feedback?.wilsonRating ?? 0));

export const getLinkToDetails = (item: ItemModel) => {
  const parsedTaxonomy = ItemTaxonomyId.Parse(item.taxonomyId!);
  const linkMap: Record<string, string> = {
    software: `/items/${parsedTaxonomy.getUrlSuffix()}`,
    aiforme: item.learnMoreLink,
  };
  return linkMap[parsedTaxonomy.dataDomain] || "";
};
